// extracted by mini-css-extract-plugin
module.exports = {"fits":"Fits_fits__N3LaI"};